import React from 'react';

export const MapPinIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18">
    <path fill="#4B4B4B" d="M6.596 17.694c-.138.192-.36.306-.596.306s-.458-.114-.596-.306C4.363 16.236 0 9.892 0 6c0-3.314 2.686-6 6-6s6 2.686 6 6c0 3.892-4.363 10.236-5.404 11.694zM6 2.25C3.929 2.25 2.25 3.93 2.25 6c0 2.071 1.679 3.75 3.75 3.75 2.071 0 3.75-1.679 3.75-3.75 0-.995-.395-1.948-1.098-2.652C7.948 2.645 6.995 2.25 6 2.25z" />
  </svg>
);
export default MapPinIcon;
